import { Injectable } from '@angular/core';
import { DateRange } from '../../shared/components/date-range/date-range.component';
import { timer ,of } from 'rxjs';
import { switchMap, retryWhen, map, filter, concatMap, mergeMap, catchError, flatMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SecurityService } from '../../shared/security.service';
import { api, retryStrategy } from '../../shared/api-loaders';
import { TransactionLog } from '../models/TransactionLog';
import { PagingInfo } from '../models/PagingInfo';


@Injectable({
  providedIn: 'root'
})
export class TransactionLogService {

  constructor(private http: HttpClient, private secSvc: SecurityService) { }


  getErrorCount() {
    return timer(0).pipe(switchMap(
      x => {
        return this.http
          .get<number>(`${api.transactionLog()}/error-count`)
      }), retryWhen(retryStrategy()));

  }

  userHasError(ssoid: string) {
    return timer(0).pipe(switchMap(
      x => {
        return this.http
          .get<number>(`${api.transactionLog()}/user-error/${ssoid}`)
      }), retryWhen(retryStrategy()));
  }

  resolve(subTransactionId: number) {
    return timer(0).pipe(switchMap(
      x => {
        return this.http
          .put(`${api.transactionLog()}/sub-transactions/resolve/${subTransactionId}`, null)
      }), retryWhen(retryStrategy()));
  }
  getTransactions(date: DateRange, status:string, searchText: string, pageNumber: number, pageSize: number, location:string) {

    let params = new HttpParams();
    params = params.set("search", searchText||"");
    params = params.set("pageNumber", pageNumber.toString());
    params = params.set("rowsPerPage", pageSize.toString());
    params = params.set("from", date.start.toJSON());
    params = params.set("to", date.end.toJSON());
    params = params.set("status", status);
    params = params.set("location", location);


    return timer(0).pipe(switchMap(
      x => {
        return this.http
          .get<PagingInfo<TransactionLog>>(`${api.transactionLog()}`, { params: params })
      }), retryWhen(retryStrategy()));

  }




  
} 
